/* verqo — SubPageRenderer (marketing site)
   Universal content-driven renderer used by every sub-page route.
   Reads a content object with optional sections and composes the page.
   Also emits SEO metadata (title/description) per page.
*/
import { useLocation } from "react-router-dom";
import {
  SubPageLayout, HeroBlock, LogoStrip, FeatureGrid, AltBlocks,
  MetricsBar, Quote, FAQ, RelatedPages, CTABanner, ScreenshotShowcase,
} from "../../../components/marketing/SubPageBlocks";
import PageSEO from "../../../components/marketing/PageSEO";

/* Build a fallback SEO title/description from the content if not explicitly provided */
function derivedSeo(content) {
  const title = content.seoTitle || content.title || "verqo";
  const description = content.seoDescription || content.subtitle || "";
  return { title, description };
}

export default function SubPageRenderer({ content, modeOverride }) {
  const { pathname } = useLocation();
  const {
    eyebrow, title, subtitle, heroCtas, heroVisual,
    logos, features, screenshots, blocks, metrics, quote, faq, related,
    cta,
  } = content;

  const seo = derivedSeo(content);

  return (
    <SubPageLayout modeOverride={modeOverride}>
      <PageSEO title={seo.title} description={seo.description} path={pathname} />
      <HeroBlock
        eyebrow={eyebrow}
        title={title}
        subtitle={subtitle}
        ctas={heroCtas}
        visual={heroVisual}
      />
      {logos && <LogoStrip items={logos.items} note={logos.note} />}
      {features && <FeatureGrid heading={features.heading} sub={features.sub} features={features.items} />}
      {screenshots && <ScreenshotShowcase heading={screenshots.heading} sub={screenshots.sub} items={screenshots.items} cta={screenshots.cta} />}
      {blocks && <AltBlocks blocks={blocks} />}
      {metrics && <MetricsBar metrics={metrics} />}
      {quote && <Quote {...quote} />}
      {faq && <FAQ items={faq} />}
      {related && <RelatedPages items={related} />}
      {cta && <CTABanner {...cta} />}
    </SubPageLayout>
  );
}
